export default "__VITE_PUBLIC_ASSET__a678cce6__"